<div class="container" [class.otp_form]="!db.normal_login" [class.web_container]="!db.ismobile">
  <div class="container-desc-header ion-text-center">
    <div class="d__flex just-c">
      <h1>Get started</h1>
      <div class="login_header mouse" routerLink="/">
        <img src="assets/favi_farmlink_L.svg" alt="">
      </div>
    </div>
    <div>
      <p class="m-0">Don’t have an account? <span class="mouse user-select alternative" (click)="clear_otp()">Sign Up</span></p>
    </div>
  </div>
  <div class="w-100" *ngIf="db.normal_login">
    <div [ngClass]="db.ismobile?'mbl-main-container main-container':'main-container'">
      <div class="log-in-title">
      </div>
      <div class="form-section">
        <form [formGroup]="loginform">
          <div class="form-item">
            <label class="medium_name">Email Address</label>
            <div class="d__flex input-item">
              <ion-icon name="mail-outline"></ion-icon>
              <ion-input type="text" placeholder="Enter the Email" name="username" formControlName="username"></ion-input>
            </div>
            <div *ngIf="submitted && !username?.valid">
              <p class="error" *ngIf="username.errors.required">Email-Id is required</p>
              <p class="m-0 error" *ngIf="username.errors.pattern">Email-Id is not valid</p>
              <p class="error" *ngIf="username.errors.email">Email-Id is not valid</p>
            </div>
          </div>
          <div class="form-item">
            <label class="medium_name">Password</label>
            <div class="d__flex input-item pos_relative">
              <ion-icon class="mouse" (click)="show_pass ?show_pass = false: show_pass = true" [name]="(show_pass)?'lock-closed-outline':'lock-open-outline'"></ion-icon>
              <ion-input [type]="(show_pass)?'password':'text'" (keyup.enter)="login()" placeholder="Enter the password" name="password" formControlName="password"></ion-input>
              <ion-icon class="eye-icon" (click)="show_pass = !show_pass" [name]="show_pass? 'eye':'eye-off'"></ion-icon>
            </div>
            <p class="m-0 error" *ngIf="submitted && !password.valid && password.errors.required"> Password is required </p>
          </div>
          <!-- <div class="forget fnt-13 ion-text-right" (click)="db.otp_form = true" (click)="forgot()">
            <span class="m-o span mouse">Forgot password?</span>
          </div> -->
          <div class="log-button">
            <ion-button expand="full" fill="clear" (click)="login()">Sign In</ion-button>
            <p class="m-0 error" *ngIf="alert_message">{{alert_message}}</p>
          </div>
        </form>
        <div>
          <div id="sign-in-button"></div>
        </div>
      </div>
    </div>
  </div>
  <div class="w-100" *ngIf="!db.normal_login">
    <app-otp-login></app-otp-login>
  </div>
  <div class="ion-text-center login-with">
    <!-- <span> </span> -->
    <span class="m-0 ion-text-center">or </span>
    <ul class="d__flex just-c">
      <li class="mouse" (click)="db.normal_login?db.normal_login = false:db.normal_login = true">
        <ion-icon [src]="db.normal_login?'/assets/icon/otp.svg':'/assets/icon/mail.svg'"></ion-icon> Login With {{db.normal_login == false ? 'Email' :'OTP'}}
      </li>
      <!-- <li class="mouse" (click)="googleLogin()"><ion-icon src="/assets/icon/google.svg"></ion-icon></li> -->
      <!-- <li class="mouse" (click)="fb_login()"><ion-icon name="logo-facebook"></ion-icon></li> -->
    </ul>
    <div class="login_footer">
      <img src="assets/icon/website-logo.svg">
    </div>
    <div class="policys">
      <p (click)="goto_terms()" class="a_tag mouse m-0">Terms & Condition</p>
      <p (click)="goto_policy()" class="a_tag mouse m-0">Privacy Policy</p>
    </div>
  </div>
  
